// extracted by mini-css-extract-plugin
export default {"infoWrapper":"HeaderCashbackComponent-module__infoWrapper__l5w9d"};